var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitingMonochromatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406 306",
    style: {
      enableBackground: "new 0 0 406 306"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.18;fill:#EBCA94;enable-background:new    ;}\r\n\t.st1{opacity:0.41;fill:#EBCA94;enable-background:new    ;}\r\n\t.st2{fill:#EBCA94;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_00000075128286626748118250000000309870484437092997_);}\r\n\t.st5{fill:#3E3E54;}\r\n\t.st6{fill:url(#SVGID_00000037679177134214036130000009408566603478262183_);}\r\n\t.st7{fill:url(#SVGID_00000026145466966828025490000006575749553384028561_);}\r\n\t.st8{fill:url(#SVGID_00000080894624178988207500000010530064808318097059_);}\r\n\t.st9{fill:url(#SVGID_00000072272198437096572900000009762073461263802036_);}\r\n\t.st10{fill:url(#SVGID_00000077282947499712305690000006748759647501338521_);}\r\n\t.st11{fill:url(#SVGID_00000004538577356271375730000004410109911152059296_);}\r\n\t.st12{fill:url(#SVGID_00000030457703524009804040000001060856785479633590_);}\r\n\t.st13{fill:url(#SVGID_00000178927941073889936520000016756133222228725385_);}\r\n\t.st14{fill:#0D4F6C;}\r\n\t.st15{fill:url(#SVGID_00000178900342348492112730000010287807250967544710_);}\r\n\t.st16{fill:url(#SVGID_00000072980367092568148090000004770503239085959606_);}\r\n\t.st17{fill:url(#SVGID_00000065763946488151255970000005768080234373867681_);}\r\n\t.st18{fill:url(#SVGID_00000009562983189136253740000012087548483067921549_);}\r\n\t.st19{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.3,279.8c-4.8,2.9-10.2,5.6-15.9,8.4c-21.5,11-46.7,12.2-70.4,13.1l-113.5,4.3c-19.1,0.7-39,1.3-56.6-6.1 c-10.2-4.4-19.1-11.2-26.3-19.6c-11.4-13.3-19-30.4-22.8-47.6c-6.2-28.1-4.3-57.4-4.7-86.2c-0.3-16.8-1.4-33.7,1.5-50.3 c2.9-16.5,10.3-33,23.9-42.9c18.2-13.3,42.1-12,63.4-14.8c22.5-3,41.7-13.9,61.8-23.8c21-10.4,44.9-15.9,68.3-13.7 c23.7,2.3,40.9,13.1,54.2,32.9c9.2,13.7,14.7,29.4,16.2,45.8c1.7,19.3-2.3,38.8,0.5,58c5.6,37.5,36.6,68,40.1,105.8 C369.8,262.6,361.1,272.1,348.3,279.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.3,279.8c-4.8,2.9-10.2,5.6-15.9,8.4c-21.5,11-46.7,12.2-70.4,13.1l-113.5,4.3c-19.1,0.7-39,1.3-56.6-6.1 c-10.2-4.4-19.1-11.2-26.3-19.6L348.3,279.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.7,62.6c-0.1,3.6,0.4,7.2,0.5,10.9c0.1,1.4,0,2.7-0.4,4c-0.9,2.5-3.3,4.1-5.6,5.5c-1.4,0.9-3.1,2.1-2.9,3.8 c0.3,1.3,1.4,2.3,2.7,2.4c1.3,0.1,2.6-0.2,3.8-0.7c2.4-0.8,4.6-2.1,6.5-3.8c3.6-3.8,3.8-9.6,3.5-14.9c-0.2-4.4-0.6-9.2-2.8-13.1 C200.4,50.2,198.8,59.4,198.7,62.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.7514,
    y1: 87.0966,
    x2: 249.3514,
    y2: 98.6866,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.7,62.6c-0.1,3.6,0.4,7.2,0.5,10.9c0.1,1.4,0,2.7-0.4,4c-0.9,2.5-3.3,4.1-5.6,5.5c-1.4,0.9-3.1,2.1-2.9,3.8 c0.3,1.3,1.4,2.3,2.7,2.4c1.3,0.1,2.6-0.2,3.8-0.7c2.4-0.8,4.6-2.1,6.5-3.8c3.6-3.8,3.8-9.6,3.5-14.9c-0.2-4.4-0.6-9.2-2.8-13.1 C200.4,50.2,198.8,59.4,198.7,62.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071522388096824146180000018214709236931181236_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.9283,
    y1: -449.8932,
    x2: -18.4214,
    y2: -449.8932,
    gradientTransform: "matrix(0.7444 0.3005 0.3005 -0.7444 342.7222 -238.6916)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#EAD4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0E9CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071522388096824146180000018214709236931181236_)"
    },
    d: "M188,84.3c-1.7-0.6-3.4-1.4-5.1-0.8 c-0.3,0.1-0.6,0.3-0.7,0.6c0,0.2,0,0.4,0.1,0.7l1.9,5.7c0.1,0.3,0.2,0.6,0.4,0.8c0.4,0.4,0.9,0.7,1.5,0.8c2.1,0.6,4.3,0.5,6.3-0.3 c2.1-0.8,2.3-3.4,1.2-5.2C192.4,84.8,189.9,85,188,84.3z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.1,74c0.5,0.1,0.3,0.5,0.4,1c0.4,3.5,0.1,7.5,0.8,10.9c0.7,3.4,3,6.5,3.5,10c-1.7-3.5-3.2-6.8-4.1-10.6 C184.5,84.4,183.2,74,184.1,74z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.6,106.9c0,0-15.9,19-5.3,35.4s29.5,28.5,36.7,40.8c7.2,12.3-5.8,25.7-10.4,28.2s-45.7,32.9-20.2,64h86.1 c0,0,27.9-28.2-18.6-62.4c0,0-33.2-16.9-2.1-41s36.7-47,21.9-64.9L198.6,106.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037682566596642427840000010332117146622443142_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5456,
    y1: -55.4777,
    x2: 387.127,
    y2: -55.4777,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037682566596642427840000010332117146622443142_)"
    },
    d: "M198.6,106.9c0,0-15.9,19-5.3,35.4 s29.5,28.5,36.7,40.8c7.2,12.3-5.8,25.7-10.4,28.2s-45.7,32.9-20.2,64h86.1c0,0,27.9-28.2-18.6-62.4c0,0-33.2-16.9-2.1-41 s36.7-47,21.9-64.9L198.6,106.9z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.9,99.2h99.6c2.3,0,4.1,1.8,4.1,4.1v0c0,2.3-1.8,4.1-4.1,4.1h-99.6c-2.3,0-4.1-1.8-4.1-4.1v0 C187.8,101,189.6,99.2,191.9,99.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.9,275.7h99.6c2.3,0,4.1,1.8,4.1,4.1v0c0,2.3-1.8,4.1-4.1,4.1h-99.6c-2.3,0-4.1-1.8-4.1-4.1v0 C187.8,277.5,189.6,275.7,191.9,275.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054965933497351743580000007454593232848678802_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.8667,
    y1: 58.9923,
    x2: 307.8667,
    y2: 78.5823,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -5.0689 158.9305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054965933497351743580000007454593232848678802_)"
    },
    d: "M191.9,99.2h99.6c2.3,0,4.1,1.8,4.1,4.1v0 c0,2.3-1.8,4.1-4.1,4.1h-99.6c-2.3,0-4.1-1.8-4.1-4.1v0C187.8,101,189.6,99.2,191.9,99.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093167363699880640500000007101085505466677147_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.3968,
    y1: -126.6978,
    x2: 307.3968,
    y2: -173.6177,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -5.0689 158.9305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093167363699880640500000007101085505466677147_)"
    },
    d: "M191.9,275.7h99.6c2.3,0,4.1,1.8,4.1,4.1v0 c0,2.3-1.8,4.1-4.1,4.1h-99.6c-2.3,0-4.1-1.8-4.1-4.1v0C187.8,277.5,189.6,275.7,191.9,275.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109031582028526275060000016489442481296147122_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.4669,
    y1: -77.8378,
    x2: 320.5786,
    y2: -112.1395,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109031582028526275060000016489442481296147122_)"
    },
    d: "M278.2,232c-14.6-7.8-62.9-9.1-72-2.4 c8.5-11.3,20.3-18,20.3-18c11.6-7.2,24.7-0.9,24.7-0.9S267.9,219.3,278.2,232z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.9,274.8h-72.1l-2.8-2.5c-8.2-14.1-6.2-26.5-0.8-36.5c1.2-2.1,2.5-4.2,4-6.1c9.2-6.7,57.4-5.4,72,2.4 c1.5,1.8,2.8,3.8,4,5.9c0.8,1.4,1.5,2.8,2,4.2C291.4,260.3,277.9,274.8,277.9,274.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096024160851611854610000007044348030739278769_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.2267,
    y1: -81.5237,
    x2: 313.0167,
    y2: -157.2537,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096024160851611854610000007044348030739278769_)"
    },
    d: "M282.2,237.9c-3.4,12.5-37.8-6.6-53.8-8 c-10.6-0.9-21.7,5.5-21.7,5.5s-3.6,1.3-4.6,0.4c1.2-2.1,2.5-4.2,4-6.1c9.2-6.7,57.4-5.4,72,2.4C279.7,233.9,281,235.8,282.2,237.9z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206,152.6c0,0,24.7,19.5,26.3,23.2s14.5,6,18.5,2.6c4-3.3,14.2-9.7,24.3-24.2c10.1-14.4-23.1-5-34.3-2.9 C229.7,153.4,210.5,139.8,206,152.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206,152.6c0,0,9.6,6.3,18.1,4.4c8.5-1.9,14.1-7.3,25.8-6.3c11.7,1,23.4,6.1,27.1,0.6c3.7-5.4-0.3-9.8-12-8.4 c-11.7,1.5-31.1,1.7-40.4,1S198.3,144.8,206,152.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119800429055407299310000004221913320880736155_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.2401,
    y1: -15.8776,
    x2: 320.0701,
    y2: 19.9424,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119800429055407299310000004221913320880736155_)"
    },
    d: "M206,152.6c0,0,9.6,6.3,18.1,4.4 c8.5-1.9,14.1-7.3,25.8-6.3c11.7,1,23.4,6.1,27.1,0.6c3.7-5.4-0.3-9.8-12-8.4c-11.7,1.5-31.1,1.7-40.4,1S198.3,144.8,206,152.6z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.6,184.9c-0.7,0.4-1.2,1.1-1.6,1.8c-0.3,0.4-0.3,1-0.2,1.5c0.2,0.6,0.8,0.9,1.4,0.9c0.5,0,1-0.2,1.4-0.6 c0.8-0.5,1.7-1.2,1.6-2C243,185.7,241.7,185.2,240.6,184.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M245,192.4c-0.3,0.1-0.5,0.2-0.7,0.4c-0.1,0.1-0.2,0.2-0.1,0.3c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.1 c0.4-0.1,0.8-0.2,0.7-0.4C246.1,192.5,245.6,192.4,245,192.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.7,194.7c-0.3,0.1-0.5,0.2-0.7,0.4c-0.1,0.1-0.2,0.2-0.1,0.3c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4,0,0.6-0.1 c0.4-0.1,0.8-0.2,0.7-0.4C241.8,194.9,241.2,194.8,240.7,194.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.6,205.7c-0.3-0.1-0.7-0.2-1.1-0.2c-0.2,0-0.4,0-0.4,0.2c0,0.3,0.1,0.5,0.4,0.6c0.2,0.2,0.4,0.3,0.7,0.4 c0.5,0.2,1,0.4,1.1,0.2C248.4,206.6,248,206.1,247.6,205.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.8,219.9c-0.3-0.1-0.7-0.2-1.1-0.2c-0.2,0-0.4,0.1-0.4,0.2c0,0.1,0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.3,0.7,0.4 c0.4,0.2,1,0.4,1.1,0.2C235.6,220.9,235.2,220.4,234.8,219.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.5,57.5c-0.1-2.1,0.4-4.3,1.6-6c1.2-1.8,2.7-3.3,4.6-4.3c1-0.7,2.2-1.1,3.4-1c1,0.1,4.6-3.7,5.4-3.1 c2.3,1.7,1.9,8.1,3.8,10.2c0.5,2.9,0.8,5.7,1,8.6l1.2,21.9c0.2,3.6,0.3,7.6-1.9,10.4c-5.5-2-10.8-4.3-15.9-7.1c-1.2-0.4-2-1.7-1.8-3 c-0.2-5.4-0.2-10.9,0-16.3C202,64.9,200.7,60.5,200.5,57.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034080679590447019010000005270320964095195834_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.2368,
    y1: 97.6246,
    x2: 258.0568,
    y2: 95.9646,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034080679590447019010000005270320964095195834_)"
    },
    d: "M200.5,57.5c-0.1-2.1,0.4-4.3,1.6-6 c1.2-1.8,2.7-3.3,4.6-4.3c1-0.7,2.2-1.1,3.4-1c1,0.1,4.6-3.7,5.4-3.1c2.3,1.7,1.9,8.1,3.8,10.2c0.5,2.9,0.8,5.7,1,8.6l1.2,21.9 c0.2,3.6,0.3,7.6-1.9,10.4c-5.5-2-10.8-4.3-15.9-7.1c-1.2-0.4-2-1.7-1.8-3c-0.2-5.4-0.2-10.9,0-16.3C202,64.9,200.7,60.5,200.5,57.5 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162322378739366085070000004026641589540161456_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.5754,
    y1: 134.9884,
    x2: 285.4654,
    y2: 134.9884,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#EAD4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0E9CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162322378739366085070000004026641589540161456_)"
    },
    d: "M196.1,41.1v0.6c0,0.8,0.2,1.6,0.6,2.2 c0.8,1,2.3,1,3.5,0.9c1-0.2,2-0.3,3-0.2c1,0.2,2.1,4.3,3,4.4c1.7,0.3,5.4-1.8,6.6-2.9c0.1-0.1-1.3-3.2-1.2-3.4c0-0.2,0-0.3,0-0.5 l-1.9-9c-0.2-1.3-0.6-2.5-1.4-3.6c-0.6-0.7-1.3-1.2-2.1-1.6c-2.7-1.2-6.7-0.8-8.7,1.7c-1.1,1.3-1,3.6-1.2,5.2 C196.1,37,196,39.1,196.1,41.1z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M210.3,103.8c-5.3,3.4-11.4,5.5-17.4,7.4c-1.5,0.5-3.2,1-4.5,0.2c-0.7-0.5-1.3-1.2-1.7-2.1 c-2.4-4.5-8.3-5.8-5.4-10c1.2-1.8,8.2-7.6,9.9-8.8c3.4-2.5,7-5.1,11.2-5.8c2-0.3,4-0.3,5.9,0c3.8,0.5,13.4,1.9,12.6,6.8 S214.1,101.3,210.3,103.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.9,61.2c0,3.2,0.3,6.4-0.7,9.4c-1.4,4-5.1,6.8-8.8,8.9c-2.3,1.3-4.8,2.7-6,5c-1.2,2.3-0.4,6,2.2,6.4 c1,0.1,2,0,3-0.4c5.1-1.7,9.9-3.8,14.6-6.4c1.9-1.1,3.8-2.3,5-4.1c1-1.9,1.6-3.9,1.6-6.1c0.4-4.5,0.2-9.1-0.4-13.6 c-0.7-3.6-2.1-7-4.1-10C211.9,41.7,211.9,56.4,211.9,61.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134928648183524613130000004265182808113599885_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.7587,
    y1: 94.2979,
    x2: 257.8486,
    y2: 97.2778,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134928648183524613130000004265182808113599885_)"
    },
    d: "M211.9,61.2c0,3.2,0.3,6.4-0.7,9.4 c-1.4,4-5.1,6.8-8.8,8.9c-2.3,1.3-4.8,2.7-6,5c-1.2,2.3-0.4,6,2.2,6.4c1,0.1,2,0,3-0.4c5.1-1.7,9.9-3.8,14.6-6.4 c1.9-1.1,3.8-2.3,5-4.1c1-1.9,1.6-3.9,1.6-6.1c0.4-4.5,0.2-9.1-0.4-13.6c-0.7-3.6-2.1-7-4.1-10C211.9,41.7,211.9,56.4,211.9,61.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088093350755982002710000014096876351445705856_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.4778,
    y1: -73.0003,
    x2: 171.6755,
    y2: -73.0003,
    gradientTransform: "matrix(0.7997 7.010746e-02 7.010746e-02 -0.7997 55.0202 51.2365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#EAD4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0E9CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088093350755982002710000014096876351445705856_)"
    },
    d: "M177,117.9l-1.4,26.3 c3.2-0.2,4.7-3.9,5.4-7c2.2-8.7,4.4-17.4,6.6-26.2c0.6-2.6,1.3-5.3,0.8-7.9c-0.4-1.9-2-5.1-4.2-5.3c-2.4-0.2-3.6,2.8-4.4,4.7 C177.6,107.3,177.3,112.7,177,117.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013155222820023636230000013677847861585070261_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.6588,
    y1: 30.0373,
    x2: 259.8488,
    y2: 30.0373,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#EAD4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0E9CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013155222820023636230000013677847861585070261_)"
    },
    d: "M181.8,119.7l0.9,26.3 c3.1-0.5,4.3-4.3,4.8-7.4c1.4-8.9,2.8-17.8,4.2-26.6c0.4-2.6,0.8-5.4,0.1-7.9c-0.5-1.8-2.5-4.9-4.7-4.9c-2.4,0-3.3,3.1-4,5 C181.5,109.1,181.6,114.5,181.8,119.7z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.4,138.8l-3,0.2c-0.6,0-1.2,0.2-1.7,0.6c-0.2,0.4-0.4,0.8-0.3,1.3c-0.1,1.6-0.1,3.2,0,4.8 c0,0.1,0,0.1,0,0.2c0.1,0.1,0.2,0.2,0.4,0.1c1.1,0,2.3-0.3,3.3-0.9c0.4-0.2,0.8-0.5,1.1-0.9c0.2-0.5,0.4-1,0.4-1.5 C180.5,141.5,180.6,140.1,180.4,138.8L180.4,138.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M180.4,144.2c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.2-0.6-0.1c-0.2,0.1-0.3,0.3-0.5,0.5c-0.5,0.6-1.2,1-2,1.1 c-0.8,0-1.6,0-2.4,0.1c-0.6,0.2-1.1,0.6-1.5,1l-2.6,2.2c-0.6,0.5-1.3,1.2-1.1,2c0.2,0.7,0.9,1.2,1.6,1.3c1.3,0.1,2.6,0,3.9-0.5 c1.2-0.3,2.3-0.7,3.4-1.1c0.6-0.2,1.1-0.6,1.5-1C180.8,148.3,180.5,145.7,180.4,144.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.6,139.2l-3,0.2c-0.6,0-1.2,0.2-1.7,0.6c-0.2,0.4-0.4,0.8-0.3,1.3c-0.1,1.6-0.1,3.2,0,4.8 c0,0.1,0,0.1,0,0.2c0.1,0.1,0.2,0.2,0.4,0.1c1.1,0,2.3-0.3,3.3-0.9c0.4-0.2,0.8-0.5,1.1-0.9c0.2-0.5,0.4-1,0.4-1.5 C187.7,141.8,187.7,140.5,187.6,139.2L187.6,139.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M187.5,144.6c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.2-0.6-0.1c-0.2,0.1-0.3,0.3-0.5,0.5c-0.5,0.6-1.2,1-2,1.1 c-0.8,0-1.6,0-2.4,0.2c-0.6,0.2-1.1,0.6-1.5,1l-2.6,2.2c-0.6,0.5-1.3,1.2-1.1,2c0.2,0.7,0.9,1.2,1.6,1.3c1.3,0.1,2.7,0,3.9-0.5 c1.2-0.3,2.3-0.7,3.4-1.1c0.6-0.2,1.1-0.6,1.5-1C188,148.6,187.7,146,187.5,144.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054246363382487422140000007297691557194246061_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.4368,
    y1: 69.8851,
    x2: 266.9668,
    y2: 69.8851,
    gradientTransform: "matrix(0.8028 0 0 -0.8028 -16.3482 146.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#EAD4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0E9CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054246363382487422140000007297691557194246061_)"
    },
    d: "M190.2,86.8c-1.8,0.1-3.7,0-5,1.2 c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0.2,0.4,0.3,0.6l3.9,4.6c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.3,1.1,0.3,1.7,0.2c2.2-0.2,4.2-1.2,5.8-2.6 c1.6-1.5,0.9-4-0.9-5.3C194.5,85.6,192.2,86.7,190.2,86.8z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M210.3,21.3c5.5,0.5,10.4,4,13.8,8.4c3.5,4.6,6.3,10.7,11.9,11.9c2.5,0.5,5.2-0.1,7.7,0.2 c4.9,0.6,8.9,4.3,9.9,9.1c0.6,3.1-0.1,6.4,0.2,9.5c0.6,6.2,5.3,12.2,3.6,18.2c-1.4,4.8-7.2,7.6-11.9,5.8c-4.9-1.9-7.1-7.6-10.4-11.7 c-1.5-1.8-3.6-3.5-5.9-3.1c-1.1,0.2-2.1,0.9-3.2,1.2c-2.6,0.7-5.2-1.1-6.6-3.5c-1.3-2.3-1.6-5-2-7.7c-0.6-3.7-1.6-7.5-4-10.3 c-3-3.5-7.8-5.2-10.1-9.2c-1.3-2.4-1.6-5.1-2.8-7.5c-1.1-2.1-3.1-3.2-2.2-5.7C199.8,22.8,206.5,21,210.3,21.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M195.2,26.8c-0.3,1.4,0.2,2.8,1.1,3.8c1,1,2,1.8,3.2,2.6c1.2,0.7,2.1,1.8,2.8,3c0.1,0.2,0.2,0.4,0.3,0.5 c0.2,0.1,0.4,0.1,0.6,0c0.1-0.1,0.1-0.2,0.1-0.4c0.2-2.2-0.2-4.5-0.2-6.7c0-1.5,0.5-3.5-0.5-4.8C200.9,22.2,195.9,24.3,195.2,26.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180,76.2c-0.1,0.6,0,1.3,0.4,1.8c0.7,0.9,2.3,0.7,3.1-0.2c0.7-1,1-2.2,0.8-3.3c-0.1,1.1,0.1,2.1,0.6,3.1 c0.6,0.9,1.9,1.4,2.7,0.7c0.4-0.4,0.7-1.1,0.6-1.7c0-1.1-0.5-2.1-1.2-2.9c0.4,0.6,1,1,1.8,1.2c0.4,0.1,0.7,0.1,1.1,0 c0.7-0.3,1.2-1,1-1.8c-0.1-0.8-0.6-1.4-1.3-1.8c-0.7-0.4-1.4-0.7-2.1-0.8c0.5-0.4,1.2-0.7,1.7-1c0.6-0.4,0.9-0.9,1-1.6 c0.1-1.1-1.2-1.9-2.3-1.8c-1.1,0.2-2.1,0.7-2.9,1.5c-0.7-0.7-1.6-1.2-2.5-1.5c-1-0.3-2,0-2.7,0.7c-0.7,0.9-0.6,2.3,0.4,3 c0.1,0.1,0.2,0.1,0.3,0.2c-0.7,0.1-1.4,0.1-2.1,0.1c-0.7,0-1.4,0.4-1.8,1c-0.3,0.8,0,1.6,0.7,2.1c0.7,0.4,1.5,0.5,2.3,0.2 c0.5-0.1,1.4-0.9,1.8-0.6C180.9,74,180.2,74.9,180,76.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 184.4,
    cy: 70.9,
    rx: 2.7,
    ry: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingMonochromatic);
export default __webpack_public_path__ + "static/media/Waiting_Monochromatic.b760b3b7f27d840cbbef7d82094f3c5a.svg";
export { ForwardRef as ReactComponent };